/* Footer: menú de marcas que se abre sobre el botón "Síguenos en nuestras redes" */
(() => {
  if (customElements.get('social-brands')) return;

  class SocialBrands extends HTMLElement {
    connectedCallback() {
      this.toggleBtn = this.querySelector('.js-sb-toggle');
      this.pop = this.querySelector('.sb__pop');
      this.brandsView = this.querySelector('.js-sb-brands');
      if (!this.toggleBtn || !this.pop) return;

      this.toggleBtn.addEventListener('click', () => (this.pop.hidden ? this.open() : this.close()));
      this.querySelectorAll('.js-sb-close').forEach((b) => b.addEventListener('click', () => this.close(true)));
      this.querySelectorAll('.js-sb-back').forEach((b) => b.addEventListener('click', () => this.show(this.brandsView)));
      this.querySelectorAll('.js-sb-brand').forEach((b) => {
        b.addEventListener('click', () => {
          const view = this.querySelector(`.js-sb-social[data-brand="${b.dataset.brand}"]`);
          if (view) this.show(view);
        });
      });

      this.onDocClick = (e) => { if (!this.pop.hidden && !this.contains(e.target)) this.close(); };
      this.onKey = (e) => { if (e.key === 'Escape' && !this.pop.hidden) this.close(true); };
      document.addEventListener('click', this.onDocClick);
      document.addEventListener('keydown', this.onKey);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('keydown', this.onKey);
    }

    open() {
      this.show(this.brandsView, false);
      this.pop.hidden = false;
      this.place();
      this.toggleBtn.setAttribute('aria-expanded', 'true');
      const first = this.pop.querySelector('.js-sb-brand');
      if (first) first.focus({ preventScroll: true });
    }

    // Mantiene el menú dentro de la pantalla (móvil o botón centrado).
    place() {
      this.pop.style.left = '';
      const r = this.pop.getBoundingClientRect();
      const margin = 12;
      let shift = 0;
      if (r.right > window.innerWidth - margin) shift = window.innerWidth - margin - r.right;
      if (r.left + shift < margin) shift = margin - r.left;
      if (shift) this.pop.style.left = `${shift}px`;
    }

    close(returnFocus) {
      this.pop.hidden = true;
      this.toggleBtn.setAttribute('aria-expanded', 'false');
      if (returnFocus) this.toggleBtn.focus({ preventScroll: true });
    }

    show(view, animate = true) {
      this.pop.querySelectorAll('.sb__view').forEach((v) => {
        v.hidden = v !== view;
        v.classList.remove('is-entering');
      });
      if (animate) {
        void view.offsetWidth;
        view.classList.add('is-entering');
        const focusable = view.querySelector('.js-sb-back, .js-sb-brand');
        if (focusable) focusable.focus({ preventScroll: true });
      }
    }
  }

  customElements.define('social-brands', SocialBrands);
})();
